import React, { useEffect, useState } from 'react'
import { CommonHeader, ConfirmationModal, ErrorSuccessModal, Loader } from '../../../../components/commons'
import { resetSession } from '../../../../redux/auth'
import { RootState } from '../../../../redux/rootReducers'
import { AddJobsTypePayload, JobDataType, JobErrorType, SingleJobTypePayload, uniqueCheckJobType } from '../../../../commonTypes/jobsType'
import {  checkUniqueJobTypeAction, getSingleJobsTypeAction, resetError, resetMessage, resetSingleJobs, resetStatusCode, resetSuccess, resetUniqiueCheckFetching, resetUniqueCheckMessage, updateJobsTypeAction } from '../../../../redux/jobs'
import { connect } from 'react-redux'
import "../../styles/jobs.scss"
import AddEditJobCard from '../../../../components/Jobs/JobsType/AddEditJobType'
import { PERIOD_OPTIONS } from '../../../../components/Jobs/JobsType/AddEditJobType/RecurringJobSetting'
import { Toaster } from 'react-hot-toast'
import {  useParams } from 'react-router-dom'
import { CREATE_JOB_ON, JOB_TYPE_OPTIONS, REPEAT_JOB_OPTIONS, WAIT_POST_PERIOD_END_DATE, WAIT_POST_PERIOD_START_DATE } from '../../../../constant/jobs'
import { formatDate } from '../../../../utils/commonFunctions'
import { COUNTRY_LABLE_VALUE } from '../../../../constant/countryCode'
import useDebounce from '../../../../customHooks/useDebounce'
import moment from 'moment'
import { SingleJobsType } from '../../../../redux/jobs/jobsType'




type AppProps = {
    token: string | null;
    success: number | null;
    fetching: boolean;
    error: string | null | undefined;
    message: string;
    statusCode: number | null;
    history?: any;
    singleJobsType: SingleJobsType;
    uniqueCheckMessage: string;
    uniqueCheckFetching: boolean;
    dispatchUpdateJobsType: (data: AddJobsTypePayload) => void;
    dispatchGetSingleJobType: (data: SingleJobTypePayload) => void;
    dispatchResetSession: () => void;
    dispatchResetError: () => void;
    dispatchResetSuccess: () => void;
    dispatchResetMessage: () => void;
    dispatchResetStatusCode: () => void;
    dispatchResetSingleJobType: () => void;
    dispatchCheckUnqiueJobType: (data: uniqueCheckJobType) => void;
    dispatchResetUniqueMessage: () => void;
    dispatchResetUniqueFetching: () => void;
}


const AddJobType = ({
    token,
    success,
    fetching,
    error,
    statusCode,
    history,
    singleJobsType,
    uniqueCheckMessage,
    uniqueCheckFetching,
    dispatchResetSession,
    dispatchResetMessage,
    dispatchUpdateJobsType,
    dispatchResetError,
    dispatchResetSuccess,
    dispatchResetStatusCode,
    dispatchGetSingleJobType,
    dispatchResetSingleJobType,
    dispatchCheckUnqiueJobType,
    dispatchResetUniqueMessage
}: AppProps) => {
    const { jobId } = useParams<any>()

    const singleJobId = history?.location?.state?.id ? history?.location?.state?.id : jobId;
    const searchTerm = history?.location?.state?.searchTerm


    const [jobData, setJobData] = useState<JobDataType>({
        jobType: "",
        shortCode: "",
        jobFrequency: JOB_TYPE_OPTIONS[0].id,
        jobDescription: "",
        nextJob: moment().add(1, 'days')?.format("DD-MM-YYYY")?.toString(),
        repeat: REPEAT_JOB_OPTIONS[0],
        periodLength: PERIOD_OPTIONS[0],
        nextPeriodEnd: moment()?.format("DD-MM-YYYY")?.toString(),
        jobCreatedOn: CREATE_JOB_ON[1],
        targetStartDate: { value: "", label: "Select..." },
        WaitPostPeriodStartDate: { value: "", label: "Select..." },
        targetEndDate: { value: "", label: "Select..." },
        WaitPostPeriodEndDate: { value: "", label: "Select Period" },
        country: { value: "IN", label: "India" },
        setJobStatus: { value: "", label: "" },
        jobStatusForOpenClose: true,
        numberOfDaysToAddComment:""

    })

    const [jobsError, setJobsError] = useState<JobErrorType>({
        jobType: "",
        shortCode: "",
        jobDescription: "",
        nextPeriodEnd: "",
        targetStartDate: "",
        WaitPostPeriodStartDate: "",
        targetEndDate: "",
        WaitPostPeriodEndDate: ""
    })
    const [showConfirmationModal, setShowConfirmationModal] = useState(false)
    useEffect(() => {
        window.scroll({
            top: 0,
            left: 0
        })
        dispatchResetMessage()
        dispatchResetError()
        dispatchResetSuccess()
        dispatchResetStatusCode()
        dispatchResetSingleJobType()
        resetData()
    }, [])


    useEffect(() => {
        if (singleJobId && token) {
            dispatchGetSingleJobType({ token, id: singleJobId })
        }
    }, [singleJobId])

    useDebounce(
        () => {
            if (jobData?.jobType) {
                const finalData = {
                    token,
                    id : jobId,
                    job_type: jobData?.jobType?.trim(),
                    operation: "update"
                }
                dispatchCheckUnqiueJobType(finalData);
            }
        },
        500,
        [jobData?.jobType]
    );
    useEffect(() => {



        if (singleJobsType?.job_type &&
            singleJobsType?.job_details &&
            singleJobsType?.short_code) {

            const { job_type, short_code,number_of_days_to_add_comment, job_details, is_recurring, recurring_job_settings: { repeat_period = "", repeat_period_length, next_period_end_date, create_job_period, next_job_start_date,
                target_start_date,
                target_end_date, country,
            } } = singleJobsType
            
            const repeatOption = REPEAT_JOB_OPTIONS?.find((e: any) => e.value == repeat_period);
            const createJobOnOption = CREATE_JOB_ON?.find((e: any) => e.value == create_job_period);
            const targetStartDate = PERIOD_OPTIONS?.find((e: any) => e.value == target_start_date?.period_length);
            const targetEndDate = PERIOD_OPTIONS?.find((e: any) => e.value == target_end_date?.period_length);
            const waitPostStartDate = WAIT_POST_PERIOD_START_DATE?.find((e: any) => e.value == target_start_date?.period);
            const waitPostEndDate = WAIT_POST_PERIOD_END_DATE?.find((e: any) => e.value == target_end_date?.period);
            const countryEdit = COUNTRY_LABLE_VALUE?.find((e: any) => e.label === country);



            if (is_recurring) {
                setJobData({
                    jobType: job_type,
                    shortCode: short_code,
                    jobFrequency: is_recurring ? JOB_TYPE_OPTIONS[1].id : JOB_TYPE_OPTIONS[0].id,
                    jobDescription: job_details,
                    nextJob: formatDate(next_job_start_date),
                    repeat: repeatOption?.value ? repeatOption : { value: "monthly", label: "Monthly" },
                    periodLength: { value: repeat_period_length, label: repeat_period_length },
                    nextPeriodEnd: formatDate(next_period_end_date),
                    jobCreatedOn: createJobOnOption?.value ? createJobOnOption : CREATE_JOB_ON[1],
                    targetStartDate: targetStartDate?.value ? targetStartDate : { value: "", label: "Select..." },
                    WaitPostPeriodStartDate: waitPostStartDate?.value ? waitPostStartDate : { value: "", label: "Select..." },
                    targetEndDate: targetEndDate?.value ? targetEndDate : { value: "", label: "Select..." },
                    WaitPostPeriodEndDate: waitPostEndDate?.value ? waitPostEndDate : { value: "", label: "Select Period" },
                    country: countryEdit?.label ? countryEdit : { value: "IN", label: "India" },
                    setJobStatus: { value: "", label: "" },
                    numberOfDaysToAddComment:number_of_days_to_add_comment?number_of_days_to_add_comment:""
                })
            }
            else {
                setJobData((prev: any) => ({
                    ...prev,
                    jobType: job_type,
                    shortCode: short_code,
                    jobFrequency: is_recurring ? JOB_TYPE_OPTIONS[1].id : JOB_TYPE_OPTIONS[0].id,
                    jobDescription: job_details,
                    country: countryEdit?.label ? countryEdit : { value: "IN", label: "India" },
                    numberOfDaysToAddComment:number_of_days_to_add_comment?number_of_days_to_add_comment:""
                }))
            }

        }

    }, [singleJobsType]);


    const handleChange = (data: any, name: string) => {
        if (name === "jobType") {
            dispatchResetUniqueMessage();

        }
        switch (name) {
            case "jobType":
            case "shortCode":
            case "numberOfDaysToAddComment":
            case "jobDescription":
                setJobData((prev: JobDataType) => ({ ...prev, [name]: data.target.value }))
                setJobsError((prev: JobErrorType) => ({ ...prev, [name]: "" }))
                break;
            case "periodEndRequired":
                setJobData((prev: JobDataType) => ({ ...prev, [name]: data.target.checked }))
                setJobsError((prev: JobErrorType) => ({ ...prev, [name]: "" }))
                break;
            case "jobFrequency":
                setJobData((prev: JobDataType) => ({ ...prev, [name]: data }))
                setJobsError((prev: JobErrorType) => ({ ...prev, [name]: "" }))
                if(data==="RecurringJob"){
                    resetRecurringData()
                }
                
                break;
            case "nextPeriodEnd":
            case "nextJob":
                setJobData((prev: JobDataType) => ({ ...prev, [name]: data }))
                setJobsError((prev: JobErrorType) => ({ ...prev, [name]: "" }))
                break;
            case "jobStatusForOpenClose":
                setJobData((prev: any) => ({ ...prev, [name]: !jobData?.jobStatusForOpenClose }))
                break;
            default:
                setJobData((prev: JobDataType) => ({ ...prev, [name]: { ...data } }))
                setJobsError((prev: JobErrorType) => ({ ...prev, [name]: "" }))
        }
    }

    const handleSubmit = () => {
        const { jobType, repeat, country,numberOfDaysToAddComment, nextJob, jobCreatedOn, jobFrequency, periodLength, jobDescription, shortCode, nextPeriodEnd, targetStartDate, WaitPostPeriodStartDate, targetEndDate, setJobStatus, WaitPostPeriodEndDate } = jobData;    
        let finalData: any = {}

        if (jobType?.trim() && shortCode?.trim() && jobDescription?.trim() && jobFrequency != "RecurringJob") {
            finalData = {
                _id: singleJobId,
                job_type: jobType,
                short_code: shortCode,
                number_of_days_to_add_comment:numberOfDaysToAddComment == 0 ? null : numberOfDaysToAddComment,
                job_details: jobDescription,
                is_recurring: jobFrequency === "RecurringJob" ? true : false,
                is_scheduled: singleJobsType?.is_scheduled,
                recurring_job_settings: {
                    repeat_period: "",
                    repeat_period_length: "",
                    next_period_end_date: "",
                    create_job_period: "",
                    next_job_start_date: "",
                    target_start_date: {
                        period_length: "",
                        period: ""
                    },
                    target_end_date: {
                        period_length: "",
                        period: ""
                    },
                    country: country?.label,
                    job_status: 1
                }
            }
            if (singleJobsType?.is_scheduled && checkDateUpdate(singleJobsType,jobData)) {
                setShowConfirmationModal(true)
            }else{
            dispatchUpdateJobsType({ data: finalData, token })
            }
        }
        else if (jobType?.trim() && shortCode?.trim() && jobDescription?.trim() && jobFrequency && repeat?.value && periodLength?.value && nextPeriodEnd && targetEndDate?.value && WaitPostPeriodEndDate?.value) {
            finalData = {
                _id: singleJobId,
                job_type: jobType,
                short_code: shortCode,
                number_of_days_to_add_comment:numberOfDaysToAddComment == 0 ? null : numberOfDaysToAddComment,
                job_details: jobDescription,
                is_recurring: jobFrequency === "RecurringJob" ? true : false,
                is_scheduled: singleJobsType?.is_scheduled,
                recurring_job_settings: {
                    recurring_job_count: singleJobsType?.recurring_job_settings?.recurring_job_count ? singleJobsType?.recurring_job_settings?.recurring_job_count : 0,
                    repeat_period: repeat?.value,
                    repeat_period_length: periodLength?.value,
                    next_period_end_date: nextPeriodEnd,
                    create_job_period: jobCreatedOn?.value,
                    next_job_start_date: nextJob,
                    target_start_date: {
                        period_length: targetStartDate?.value,
                        period: WaitPostPeriodStartDate?.value
                    },
                    target_end_date: {
                        period_length: targetEndDate?.value,
                        period: WaitPostPeriodEndDate?.value
                    },
                    country: country?.label,
                    job_status: 1
                }
            }
            if (singleJobsType?.is_scheduled && checkDateUpdate(singleJobsType,jobData)) {
                setShowConfirmationModal(true)
            }else{
            dispatchUpdateJobsType({ data: finalData, token })
            }
        }
        else {
            setJobsError((prev: JobErrorType) => ({
                ...prev,
                ...(!jobType?.trim() ?
                    { jobType: 'Job Type Required' } : { jobType: '' }),
                ...(!shortCode?.trim() ?
                    { shortCode: 'Short Code Required' } : { shortCode: "" }),
                ...(!jobDescription?.trim() ?
                    { jobDescription: 'Job Description Required' } : { jobDescription: "" }),
                ...((!nextPeriodEnd && jobFrequency === "RecurringJob") ? {
                    nextPeriodEnd: 'Required',
                } : { nextPeriodEnd: "" }),
                ...(!targetEndDate?.value && jobFrequency === "RecurringJob" ? {
                    targetEndDate: 'Required',
                } : { targetEndDate: "" }),
                ...(!WaitPostPeriodEndDate?.value && jobFrequency === "RecurringJob" ? {
                    WaitPostPeriodEndDate: 'Required',
                } : { WaitPostPeriodEndDate: "" })
            }))
        }
    }

    const resetData = () => {
        setJobsError({
            jobType: "",
            shortCode: "",
            jobDescription: "",
            nextPeriodEnd: "",
            targetStartDate: "",
            WaitPostPeriodStartDate: "",
            targetEndDate: "",
            WaitPostPeriodEndDate: "",
        })

        setJobData({
            jobType: "",
            shortCode: "",
            numberOfDaysToAddComment:"",
            jobFrequency: JOB_TYPE_OPTIONS[0].id,
            jobDescription: "",
            nextJob: moment().add(1, 'days')?.format("DD-MM-YYYY")?.toString(),
            repeat: REPEAT_JOB_OPTIONS[0],
            periodLength: PERIOD_OPTIONS[0],
            nextPeriodEnd: moment()?.format("DD-MM-YYYY")?.toString(),
            jobCreatedOn: CREATE_JOB_ON[1],
            targetStartDate: { value: "", label: "Select..." },
            WaitPostPeriodStartDate: { value: "", label: "Select..." },
            targetEndDate: { value: "", label: "Select..." },
            WaitPostPeriodEndDate: { value: "", label: "Select Period" },
            country: { value: "IN", label: "India" },
            setJobStatus: { value: "", label: "" }
        })
    }

    const resetRecurringData=()=>{
        let todaysDate=`${new Date().getDate().toString().padStart(2, '0')}-${(new Date().getMonth() + 1).toString().padStart(2, '0')}-${new Date().getFullYear()}`
        setJobData((prev:JobDataType)=>({
            ...prev,
            nextJob: moment().add(1, 'days')?.format("DD-MM-YYYY")?.toString(),
            repeat: REPEAT_JOB_OPTIONS[0],
            periodLength: PERIOD_OPTIONS[0],
            nextPeriodEnd: moment()?.format("DD-MM-YYYY")?.toString(),
            jobCreatedOn: CREATE_JOB_ON[1],
            targetStartDate: { value: "", label: "Select..." },
            WaitPostPeriodStartDate: { value: "", label: "Select..." },
            targetEndDate: { value: "", label: "Select..." },
            WaitPostPeriodEndDate: { value: "", label: "Select Period" },
            setJobStatus: { value: "", label: "" }
        }))
    }

    function checkDateUpdate(prevData:any, updatedData:any) {
        prevData = prevData?.recurring_job_settings
        let flag = false;
        const isRecurring=updatedData?.jobFrequency === "RecurringJob" ? true : false;
        if (singleJobsType?.is_recurring !=isRecurring ) {
          return flag = true;
        }
        else if (prevData?.repeat_period != updatedData?.repeat?.value) {
          return flag = true;
        }
        else if (prevData?.repeat_period_length != updatedData?.periodLength?.value) {
            return flag = true;
        }
        else if (prevData?.create_job_period != updatedData?.jobCreatedOn?.value) {
            return flag = true;
        }
        else if (prevData?.target_start_date.period_length != updatedData?.targetStartDate?.value) {
            return flag = true;
        }
        else if (prevData?.target_start_date.period != updatedData?.WaitPostPeriodStartDate?.value) {
            return flag = true;
        }
        else if (prevData?.target_end_date.period_length != updatedData?.targetEndDate?.value) {
            return flag = true;
        }
        else if (prevData?.target_end_date.period != updatedData?.WaitPostPeriodEndDate?.value) {
            return flag = true;
        }
        else if (moment(prevData?.next_period_end_date).format("DD-MM-YYYY") != updatedData?.nextPeriodEnd) {
            return flag = true; 
        }   
        else if (moment(prevData?.next_job_start_date).format("DD-MM-YYYY") != updatedData?.nextJob) {
            return flag = true;   
        }   
        return flag   
      }

      const afterConfirmation=()=>{
        const { jobType, repeat, country, nextJob, jobCreatedOn, jobFrequency, periodLength, jobDescription, shortCode, nextPeriodEnd, targetStartDate, WaitPostPeriodStartDate, targetEndDate, setJobStatus, WaitPostPeriodEndDate } = jobData;    
        let finalData: any = {}
        if (jobType?.trim() && shortCode?.trim() && jobDescription?.trim() && jobFrequency != "RecurringJob") {
            finalData = {
                _id: singleJobId,
                job_type: jobType,
                short_code: shortCode,
                job_details: jobDescription,
                is_recurring: jobFrequency === "RecurringJob" ? true : false,
                is_scheduled: singleJobsType?.is_scheduled,
                recurring_job_settings: {
                    repeat_period: "",
                    repeat_period_length: "",
                    next_period_end_date: "",
                    create_job_period: "",
                    next_job_start_date: "",
                    target_start_date: {
                        period_length: "",
                        period: ""
                    },
                    target_end_date: {
                        period_length: "",
                        period: ""
                    },
                    country: country?.label,
                    job_status: 1
                }
            }
            dispatchUpdateJobsType({ data: finalData, token })
        }
        else if (jobType?.trim() && shortCode?.trim() && jobDescription?.trim() && jobFrequency && repeat?.value && periodLength?.value && nextPeriodEnd && targetEndDate?.value && WaitPostPeriodEndDate?.value) {
            finalData = {
                _id: singleJobId,
                job_type: jobType,
                short_code: shortCode,
                job_details: jobDescription,
                is_recurring: jobFrequency === "RecurringJob" ? true : false,
                is_scheduled: singleJobsType?.is_scheduled,
                recurring_job_settings: {
                    recurring_job_count: singleJobsType?.recurring_job_settings?.recurring_job_count ? singleJobsType?.recurring_job_settings?.recurring_job_count : 0,
                    repeat_period: repeat?.value,
                    repeat_period_length: periodLength?.value,
                    next_period_end_date: nextPeriodEnd,
                    create_job_period: jobCreatedOn?.value,
                    next_job_start_date: nextJob,
                    target_start_date: {
                        period_length: targetStartDate?.value,
                        period: WaitPostPeriodStartDate?.value
                    },
                    target_end_date: {
                        period_length: targetEndDate?.value,
                        period: WaitPostPeriodEndDate?.value
                    },
                    country: country?.label,
                    job_status: 1
                }
            }
            dispatchUpdateJobsType({ data: finalData, token })
        }
      }



    const handleErrorModal = () => {
        if (success === 0) {
            if (statusCode === 401) {
                return (
                    <ErrorSuccessModal
                        type="error"
                        isOpen={!!error}
                        title="Error"
                        message="Session Expired. Please Login Again!"
                        buttonText="Logout"
                        onPress={() => dispatchResetSession()}
                        statusCode={statusCode}
                    />
                )
            } else if ((!!error && statusCode !== 401)) {
                return (
                    <ErrorSuccessModal
                        type="error"
                        isOpen={!!error}
                        title="Error"
                        message={error}
                        buttonText="OK"
                        onPress={() => {
                            dispatchResetSuccess();
                            dispatchResetError();
                        }}
                    />
                )
            }
        }
        else if (success === 1) {
            return (
                <ErrorSuccessModal
                    type="success"
                    isOpen={success === 1}
                    title="Success"
                    message="Job Type Updated Successfully"
                    buttonText="OK"
                    onPress={() => {
                        dispatchResetSuccess();
                        history?.push({
                            pathname:"/jobs/jobs-type",
                            state:{searchTerm}
                        })
                        // history.goBack();
                    }}
                    statusCode={statusCode}
                />
            )
        }

        return false;
    }

    return (
        <div className="row">
            <div className="col-md-4 mb-3">
                <CommonHeader title="Edit Job Type" />
            </div>

            <div className="col-md-12">
                <div className='jobs-card' style={{ padding: "15px 30px" }}>

                    <div className='heading'> Edit Job Type</div>
                    <div className='sub-heading'>Edit details of create job type.</div>

                    <AddEditJobCard
                        jobData={jobData}
                        handleChange={handleChange}
                        jobsError={jobsError}
                        handleSubmit={handleSubmit}
                        history={history}
                        fetching={fetching}
                        type={"editJob"}
                        uniqueCheckMessage={uniqueCheckMessage}
                        uniqueCheckFetching={uniqueCheckFetching}
                        searchTerm={searchTerm}
                    />

                </div>
            </div>
            {showConfirmationModal && (
                <ConfirmationModal
                    toggle={() => {
                        setShowConfirmationModal(!showConfirmationModal);
                    }}
                    isOpen={showConfirmationModal}
                    message={`You're changing the details of Job Type. All of the scheduling will be deleted. Are you sure you want to continue?`}
                    confirmButtonText={"Continue"}
                    onPressConfirm={() => {
                        setShowConfirmationModal(!showConfirmationModal);
                        afterConfirmation()
                    }}
                />
            )}
            {handleErrorModal()}
            {fetching && <Loader />}
            <Toaster />
        </div>
    )
}

const mapStateTopProps = (state: RootState) => ({
    token: state.auth.token,
    fetching: state.jobs.jobTypeFetching,
    success: state.jobs.success,
    statusCode: state.jobs.statusCode,
    error: state.jobs.error,
    message: state.jobs.message,
    singleJobsType: state.jobs.singleJobsType,
    uniqueCheckMessage: state.jobs.uniqueCheckMessage,
    uniqueCheckFetching: state.jobs.uniqueCheckFetching
});

const mapDispatchToProps = (dispatch: any) => ({
    dispatchResetSession: () => dispatch(resetSession()),
    dispatchResetMessage: () => dispatch(resetMessage()),
    dispatchResetSuccess: () => dispatch(resetSuccess()),
    dispatchResetStatusCode: () => dispatch(resetStatusCode()),
    dispatchResetError: () => dispatch(resetError()),
    dispatchUpdateJobsType: (data: AddJobsTypePayload) => dispatch(updateJobsTypeAction(data)),
    dispatchGetSingleJobType: (data: SingleJobTypePayload) => dispatch(getSingleJobsTypeAction(data)),
    dispatchResetSingleJobType: () => dispatch(resetSingleJobs()),
    dispatchCheckUnqiueJobType: (data: uniqueCheckJobType) => dispatch(checkUniqueJobTypeAction(data)),
    dispatchResetUniqueMessage: () => dispatch(resetUniqueCheckMessage()),
    dispatchResetUniqueFetching: () => dispatch(resetUniqiueCheckFetching()),
})

export default connect(mapStateTopProps, mapDispatchToProps)(AddJobType)